import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Skeleton.module.css';

const bindClasses = classNameBind.bind(styles);
const Skeleton = ({ width, height, roundBorder }) => (
  <span
    data-ppuc-id="Skeleton"
    className={bindClasses('skeleton-box', { roundBorder })}
    style={{ width, height }}
  />
);

export default Skeleton;
